import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero" id="accueil" style={{
      background: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${process.env.PUBLIC_URL}/images/hero-bg.png) center/cover no-repeat`
    }}>
      <div className="hero-overlay">
        <div className="hero-content">
          <img
            src="/images/logo-blanc.png"
            alt="THE RECAP Logo"
            className="hero-logo fade-in"
          />
          <h1 className="hero-title fade-in">
            Le décryptage des événements qui comptent
          </h1>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
